import { render } from 'react-dom';
import type { Store } from 'redux';
import type { AppHistory } from '../store';
import { App } from './App';
import ErrorBoundary from './ErrorBoundary';
import { loadConfigFromRootDataset } from '../config';

export const buildUi = (isProd: boolean, store: Store, history: AppHistory): void => {
    const container = document.getElementById('root');
    const config = loadConfigFromRootDataset(container);

    let app = <App config={config} store={store} history={history} />;

    if (isProd) {
        app = <ErrorBoundary>{app}</ErrorBoundary>;
    }

    render(app, container);
};
